module.exports = __webpack_public_path__ + "static/media/A18040103_10004_5.5655ad7f.jpg";